import Container from "react-bootstrap/Container";
import {Col, Row} from "react-bootstrap";
import { Linkedin } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

function Footer() {
    return (
     <Container>
         <Row className="align-items-center gy-3">
             <Col md={6}>
                 <p className="mb-1 fw-semibold text-light">The perimeter is identity.</p>
                 <small className="d-block text-white-50">© {new Date().getFullYear()} Arkodomo. All rights reserved.</small>
             </Col>
             <Col md={6} className="text-md-end">
                 <a href="https://www.linkedin.com/company/arkodomo" target="_blank" rel="noopener noreferrer" className="text-light" aria-label="LinkedIn"><Linkedin size={20} /></a>
                 <span className="ms-3">
                     <Link to="/privacy" className="text-white-50 me-3">Privacy</Link>
                     <Link to="/contact" className="text-white-50">Contact</Link>
                 </span>
             </Col>
         </Row>
     </Container>
    )
}
export default Footer;
